import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';


declare let $: any;
declare let Swal:any;

@Component({
    selector : 'equip-action',
    templateUrl:'equipAction.html'
})
export class EquipActionComponent implements OnInit{

  public linkForm: FormGroup;
  public option:'body'

  public constructor(public translate: TranslationService,public _appData : AppDataService,private fb : FormBuilder, private _companyService : CompanyService) {
    this.linkForm = this.fb.group({
      x: 0,
      y: 0,
      z: 0,
      rx: 0,
      ry: 0,
      rz: 0,
      size:0,
      assetId:''
    });
  }
  public saveData(){
    let grip = this.linkForm['_value'];
    if (!this._appData.action){
      this._appData.action={kind:'equipable',param:{}}
    }
    if (grip.assetId){
      this._appData.action.param.assetId=grip.assetId     
    }
    grip.assetId=null;
    delete grip.assetId
    this._appData.action.param.grip=grip
    this._appData.action.param.location=this.option

    document.getElementById('trigger-action-done').click();
  }
  public selectOption(option){
    this.option=option
  }
  public reload(){
    let action = this._appData.action;
    if (action.param && action.param.grip) {
      action.param.grip.assetId=action.param.assetId;
      this.linkForm = this.fb.group(action.param.grip)
    }
    if (action.param.location){
      this.option=action.param.location
    }    
  }
    public ngOnInit(): any {
    }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/equipAction.ts